let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kMvga")).then(() => parcelRequire('aQoI6'));